module.exports = __webpack_public_path__ + "img/icb-empty-Inte-m@3x.28cbc970.png";